import EstateVisualVue from './controllers/estate-visual-vue';

window.application.register('estate-visual-vue', EstateVisualVue);
